<template>
    <div class="top-brand-sale">
        <div v-show="loading" style="text-align: center; padding: 25px 0; padding-bottom: 0;">
            <inline-loader></inline-loader>
        </div>
        <v-container grid-list-md fluid class="">
            <div class="top-brand-sale__swiper">
                <div class="swiper-wrapper">
                    <!-- <div class="swiper-slide" v-for="brand in brands.data" :key="brand.id" @click="redirectToProduct(brand.id)"> -->
                    <div class="swiper-slide" v-for="brand in brands.data" :key="brand.id">
                        <div class="product-item">
                            <div class="product-item__content">
                                <div class="product-item__img">
                                    <v-img :src="brand.primary_image" lazy-src="https://digima.sgp1.digitaloceanspaces.com/mybarko/item-placeholder.svg" aspect-ratio="1.2" contain></v-img>
                                </div>
                                <div class="product-item__details">
                                    <div class="product-item__details-name">{{ brand.name }}</div>
                                </div>
                                <!--<v-btn depressed dark small class="text-capitalize" color="#ff0000" @click="redirectToSeller">Shop Now</v-btn>-->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Add Arrows -->
                <!-- <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div> -->
            </div>
        </v-container>
    </div>
</template>

<script>
    import Swiper from "swiper";
    export default {
        data() {
            return {
                // topBrandOnSale: [{
                //         brandName: "Sony Philippines",
                //         brandImg: require('../assets/product/brands/sony.png'),
                //     },
                //     {
                //         brandName: "Aiwa",
                //         brandImg: require('../assets/product/brands/aiwa.jpg'),
                //     },
                //     {
                //         brandName: "Samsung Philippines",
                //         brandImg: require('../assets/product/brands/samsung.png'),
                //     },
                //     {
                //         brandName: "Nike",
                //         brandImg: require('../assets/product/brands/nike-logo.jpg'),
                //     },
                // ],
                brands: [],
                loading: false,
            }
        },
        methods: {
            redirectToSeller() {
                this.$router.push({
                    path: '/seller-page',
                })
            },
            getList() {
                this.loading = true
                axios.get(`/api/g/brand`)
                    .then(response => {
                        this.brands = response.data.data
                        this.brands.data.forEach((data, key) =>
                        {
                            if (data == null)
                            {
                                this.brands.data[key].primary_image = data.gallery.url_thumbnail
                            } else {
                                this.brands.data[key].primary_image = data.gallery.url_thumbnail
                            }
                        })
                    })
                    .catch(err => {
                        // this.toaster('something went wrong', 201);
                    })
                    .finally(() => {
                        this.loading = false
                        this.loadSwiper()
                    });
            },
            loadSwiper() {
                let swiper = new Swiper(".top-brand-sale__swiper", {
                    slidesPerView: 5,
                    spaceBetween: 16,
                    freeMode: true,
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                            640: {
                            slidesPerView: 3,
                            spaceBetween: 10,
                        },
                            380: {
                            slidesPerView: 3,
                            spaceBetween: 8,
                        },
                            320: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                        }
                    }
                });
            }
        },
        mounted() {
            this.getList()
        }
    }

</script>

<style lang="scss">
    .top-brand-sale__swiper {
        position: relative;

        .product-item {
            display: grid;
            grid-template-columns: 1fr;

            .product-item__img {
                border: 1px solid rgba(#dfe4ea, .85);
            }
        }
    }
</style>
